import { createGlobalStyle } from "styled-components";

const MainDefaultStyle = createGlobalStyle`

  body, *{
    line-height: normal;
    letter-spacing: normal;
  }

  body{
    background-color: #ffffff !important;
  }

  .Mui-selected {
    background-color: yellow;
  }

  .MuiTabs-flexContainer {
    display: "flex";
    flex-direction: "column";
  }

  .MenuItem {
    color: black;
  }
  .MenuItem.selected { /* Increase the specificity */
    color: blue;
  }

  .ck-content {
    font-size: 16px;
    height: 323px;
  }

  .ck-editor__main {
    height: 323px;
  }

  .ql-container.ql-snow {
    border: 1px solid #ccc;
    height: 323px;
  }

  .app{
    display: flex;
    flex: 1;
    padding: 0;
    .appContent{
      display: flex;
      flex: 1;
      padding: 0;
    }
  }

  .MuiTooltip-popper{
    .MuiTooltip-tooltip{
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(4px);
      margin: 8px 6px;
      padding: 6px 10px;
      font-size: 12px;
      color: #ffffff;
    }
  }

`;


export default MainDefaultStyle;
